<app-header></app-header>
<div class="app-body">
  <app-sidebar></app-sidebar>
  <!-- Main content -->
  <main class="main">
    <div class="container-fluid">
      <br>
      <router-outlet></router-outlet>
    </div>
    <!-- /.conainer-fluid -->
  </main>
</div>
<app-footer></app-footer>